import PropTypes from 'prop-types';
import useAssetTypeSelect from './useAssetTypeSelect';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

const SelectAssetType = ({ placeholder, multiple = false, includeOnlyGeoActive = false, onChange, value, width }) => {
  const { assetsTypes, isLoading, getAssetTypes } = useAssetTypeSelect({includeOnlyGeoActive});
  const { translate: t } = useDictionaryTranslation();

  const transformedAssets = assetsTypes.map((assetType) => ({
    value: assetType._id,
    label: assetType.name,
    data: assetType
  }));

  return (
    <>
      <DropdownSelect
        style={{ width: width ? '100%' : '74%' }}
        placeholderText={placeholder || t('selectAssetType')}
        onSearch={getAssetTypes}
        isLoading={isLoading}
        options={transformedAssets}
        multiple={multiple}
        onChange={onChange}
        value={value}
      />
    </>
  );
};

export default SelectAssetType;

SelectAssetType.propTypes = {
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.object,
  width: PropTypes.bool,
  includeOnlyGeoActive: PropTypes.bool
};
